"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(props) {
  return _react2.default.createElement("div", { className: "viewer-image-loading" });
};

exports.default = Loading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-wx-images-viewer/dist/components/Loading.js
// module id = 1506
// module chunks = 20 22 53